module.exports = __webpack_public_path__ + "img/banner.cd2cc224.svg";